(function () {
  'use strict';
  const key = (i, f) => '_bd155_p' + String(i).padStart(2, '0') + '_' + f;
  function mount(holder, quantity, initial, selectors) {
    if (holder.bd159Public) return holder.bd159Public;
    const copy = JSON.parse(holder.querySelector('[data-bd159-copy]').textContent);
    const persons = holder.querySelector(selectors.persons), countLabel = holder.querySelector(selectors.count);
    const label = document.createElement('label'); label.className = 'bd155-defer';
    const self = document.createElement('input'); self.type = 'checkbox'; self.dataset.bd159Self = '';
    const legacy = Object.keys(initial).some(k => /^_bd155_p\d+_/.test(k));
    self.checked = initial._bd159_self === 'yes' || (initial._bd159_self !== 'no' && !legacy);
    const text = document.createElement('span'); text.textContent = copy.self; label.append(self, text);
    const hint = document.createElement('p'); hint.textContent = copy.hint; hint.setAttribute('role', 'status');
    holder.insertBefore(label, persons); holder.insertBefore(hint, persons);
    const rows = [];
    function sync() {
      const amount = Number(quantity.value), count = Number.isInteger(amount) ? Math.max(0, Math.min(20, amount)) : 0;
      while (rows.length < count) {
        const i = rows.length + 1, person = document.createElement('fieldset'); person.className = 'bd155-person'; person.dataset.person = String(i);
        const legend = document.createElement('legend'); legend.textContent = copy.person + ' ' + i;
        const laterLabel = document.createElement('label'); laterLabel.className = 'bd155-defer';
        const later = document.createElement('input'); later.type = 'checkbox'; later.dataset.defer = ''; later.checked = initial[key(i, 'defer')] === 'ja';
        const laterText = document.createElement('span'); laterText.textContent = copy.later; laterLabel.append(later, laterText);
        const grid = document.createElement('div'); grid.className = 'bd155-fields';
        const fields = {};
        ['first', 'last', 'email'].forEach(f => {
          const l = document.createElement('label'), t = document.createElement('span'), input = document.createElement('input');
          t.textContent = copy[f]; input.type = f === 'email' ? 'email' : 'text'; input.maxLength = f === 'email' ? 160 : 80;
          input.dataset.field = f; input.autocomplete = 'off'; input.value = initial[key(i, f)] || '';
          input.addEventListener('input', () => input.setCustomValidity(''));
          l.append(t, input); grid.append(l); fields[f] = input;
        });
        person.append(legend, laterLabel, grid); persons.append(person); later.addEventListener('change', sync);
        rows.push({person, later, fields, index:i});
      }
      rows.forEach(r => {
        const active = r.index <= count && !(self.checked && r.index === 1);
        r.person.hidden = !active; r.person.disabled = !active; r.later.disabled = !active;
        Object.values(r.fields).forEach(input => {input.disabled = !active; input.required = active && !r.later.checked; if (!input.required) input.setCustomValidity('');});
      });
      hint.hidden = !self.checked || count === 0; label.hidden = count === 0;
      countLabel.textContent = count + ' ' + (count === 1 ? copy.person : copy.persons);
      return count;
    }
    function properties(current) {
      const count = sync();
      const result = Object.fromEntries(Object.entries(current || {}).filter(([k]) => !k.startsWith('_bd155_p') && !/^Teilnehmende Person \d+$/.test(k) && k !== 'Teilnehmendenangaben'));
      result._bd159_audience = 'public'; result._bd159_self = self.checked && count > 0 ? 'yes' : 'no'; result._bd159_version = '2026-10-30';
      let deferred = 0;
      rows.filter(r => r.index <= count).forEach(r => {
        const i = r.index;
        if (self.checked && i === 1) {result[key(i, 'source')] = 'checkout'; result[key(i, 'defer')] = 'nein'; result['Teilnehmende Person ' + String(i).padStart(2, '0')] = copy.source; return;}
        result[key(i, 'source')] = 'participant'; result[key(i, 'defer')] = r.later.checked ? 'ja' : 'nein';
        if (r.later.checked) deferred++;
        Object.entries(r.fields).forEach(([f,input]) => {const value = input.value.trim(); if (value) result[key(i,f)] = value;});
        const name = ['first','last'].map(f => r.fields[f].value.trim()).filter(Boolean).join(' ');
        result['Teilnehmende Person ' + String(i).padStart(2, '0')] = name || copy.later;
      });
      result.Teilnehmendenangaben = count + ' ' + (count === 1 ? copy.person : copy.persons) + '; ' + deferred + ' ' + copy.summary;
      return result;
    }
    self.addEventListener('change', sync); quantity.addEventListener('input', sync);
    holder.bd159Public = {sync, properties}; sync(); return holder.bd159Public;
  }
  window.BDPublicParticipants = {mount};
})();
